<div class="back">



 <section class="testimonial py-5" id="testimonial">
    <div class="container">
        
        <div class="row shadow-lg">
         
            <div class="col-md-4 py-5 bg-success text-white text-center ">
                <div class=" ">
                    <div class="card-body">
                        <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style="width:20%">
                        <h2 class="py-3">Complain Status</h2>
                        <p>Enter your complain ID if known OR registered Aadhar number and Phone number to know complain status
                       </p>
                    </div>
                </div>
            </div>
            <div class="col-md-8 shadow-sm py-5 border">


                <h4 class="pb-4 text-info">Please fill with your details</h4>
                <form #f="ngForm" (ngSubmit)="getUserComplains(f)">
                  <div class="form-row"  *ngIf="showMsg" >
                    <div class="col-md-12">
                      
                    <p class="alert alert-warning alert-dismissible">

                        <i class="material-icons" style="color:red;display:inline-flex;vertical-align:text-bottom;">report_problem</i>
                        <strong> No matching complain found for the given information !</strong>
                        <button type = "button" class = "close" data-dismiss = "alert" aria-hidden = "true">
                          &times;
                       </button>
                      </p>

                  </div>
  
                </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <input id="complId" name="complId" placeholder="Complain ID" class="form-control shadow-sm" type="text" required ngModel>
                    </div>
              </div>
                  <div class="col-md-6 col-sm-6"><h2 class="text-center">OR</h2></div>

                  <div class="form-row">
                        <div class="form-group col-md-6">
                          <input id="aadhar" name="aadhar" placeholder="Aadhar no." class="form-control shadow-sm" type="text" required ngModel>
                        </div>
                        <div class="form-group col-md-6">
                          <input type="text" class="form-control shadow-sm" id="phone" name="phone" placeholder="Phone No." required  ngModel>
                        </div>
                  </div>
                    
                    <div class="form-row">
                      <div class="form-group col-md-2">
                        <button type="submit" name="submit" class="btn btn-info">Submit</button>
                      </div>
                      <div class="form-group col-md-4">
                        <button type="button" name="clear" class="btn btn-info" (click)="reset(f);$event.preventDefault()">Clear</button>
                    </div>
                      </div>

                </form>
                
            </div>

            
        </div>
    </div>
 </section>
</div>





<div class="container">
<div class="row justify-content-center" *ngIf="showTableHeader">       
  <table class="table table-striped">
    <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col" class="priority-5" sortable="id">Complain Id</th>
      <th scope="col" class="priority-1" sortable="subject" >Subject</th>
      <th scope="col" class="priority-5" sortable="sc">Sub Category</th>
      <th scope="col" class="priority-1" sortable="status">Status</th>
      <th scope="col" class="priority-5" sortable="createTine">Create Time</th>
      <th scope="col" class="priority-1" sortable="updateTime">Update Time</th>
      <th scope="col">Details</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let complain of complains;let i=index;">
    <tr>
      <th class="priority-1"   scope="row">{{i+1}}</th>
      <td class="priority-5">{{ complain.id }}</td>
      <td class="priority-1">{{ complain.complCategory}}</td>
      <td class="priority-5">{{ complain.subCategory }}</td>
      <td class="priority-1">{{ complain.status }}</td>
      <td class="priority-5">{{ complain.createTime }}</td>
      <td class="priority-1">{{ complain.updateTime }}</td>
      <!-- <td class="priority-1" *ngIf="complain.expanded"><i class="material-icons" style="color:red" (click)="complain.expanded = !complain.expanded" [attr.data-target]="'#demo' + i">expand_more</i></td>
      <td class="priority-1" *ngIf="!complain.expanded"><i class="material-icons" style="color:red" (click)="complain.expanded = !complain.expanded" [attr.data-target]="'#demo' + i">expand_less</i></td> -->
      <td class="priority-1"><i class="material-icons" style="color:red" (click)="complain.expanded = !complain.expanded" [attr.data-target]="'#demo' + i">{{ complain.expanded ? '&ndash;' : '+'}}</i></td>
      <!-- <td><i class="material-icons" style="color:red" (click)="$event.stopPropagation();deleteCar(car.car_id)">open_in_full</i></td> -->
    
    </tr>
    <ng-container *ngIf="complain.expanded">
    <tr *ngFor="let details of findDetails(complain)">
      <!-- <td colspan="6" class="hiddenRow"> -->
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td> {{details.createTime}} </td>
        <td> {{details.event}} </td>
  </tr>
</ng-container>
</ng-container>
    </tbody>
  </table>               
</div>
</div>